import primaryColors from "./primaryColors";
import webSiteSetting from "./webSiteSettings";

export { primaryColors, webSiteSetting };
